export default __webpack_public_path__ + "static/media/city-topview.8194241f.png";